export const DEPENDENT_COLORS = [
  { bg: 'bg-blue-100', text: 'text-blue-700', dot: 'bg-blue-500', border: 'border-blue-300' },
  { bg: 'bg-purple-100', text: 'text-purple-700', dot: 'bg-purple-500', border: 'border-purple-300' },
  { bg: 'bg-amber-100', text: 'text-amber-700', dot: 'bg-amber-500', border: 'border-amber-300' },
  { bg: 'bg-rose-100', text: 'text-rose-700', dot: 'bg-rose-500', border: 'border-rose-300' },
  { bg: 'bg-teal-100', text: 'text-teal-700', dot: 'bg-teal-500', border: 'border-teal-300' },
];

export function getDependentColor(index: number) {
  return DEPENDENT_COLORS[index % DEPENDENT_COLORS.length];
}

interface DependentBadgeProps {
  name: string;
  colorIndex: number;
}

export function DependentBadge({ name, colorIndex }: DependentBadgeProps) {
  const color = getDependentColor(colorIndex);
  return (
    <span className={`inline-flex items-center gap-1 ${color.text}`}>
      <span className={`w-2 h-2 rounded-full ${color.dot} shrink-0`} />
      <span className="text-xs font-semibold">{name.charAt(0).toUpperCase()}</span>
    </span>
  );
}
